import React from "react";
import BudgetImage from "../../assets/budget/budget.webp";
const Budget2025 = () => {
  return (
    <>
      <div className="p-5 bg-gray-100">
        <h1 className="text-2xl font-bold text-center mb-4">BUDGET</h1>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-center p-6 bg-white rounded-xl shadow-lg">
        <div className="w-full md:w-1/2">
          <img
            src={BudgetImage}
            alt="Budget 2025"
            className="rounded-xl w-full"
          />
        </div>
        <div className="w-full md:w-1/2 p-6 bg-gray-100 rounded-xl">
          <h2 className="text-xl font-bold mb-4">
            Fill Out to download{" "}
            <span className="text-blue-600">Budget 2025</span> PPT
          </h2>
          <form className="space-y-4">
            <input
              type="text"
              placeholder="Name"
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <div className="flex space-x-2">
              <select className="p-2 border border-gray-300 rounded-md">
                <option>India - +91</option>
                <option>USA - +1</option>
                <option>UK - +44</option>
              </select>
              <input
                type="text"
                placeholder="Phone Number"
                className="flex-1 p-2 border border-gray-300 rounded-md"
              />
            </div>
            <input
              type="email"
              placeholder="Email Address"
              className="w-full p-2 border border-gray-300 rounded-md"
            />
            <button
              type="submit"
              className="w-full p-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700"
            >
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Budget2025;
